import { Mesh, Scene, Vector3, VertexData } from '@babylonjs/core';
import earcut from 'earcut';

export function CreatePolygon3D(
    name: string,
    points: Array<Vector3>,
    scene: Scene
): Mesh {
    const mesh = new Mesh(name, scene);

    const flatPoints = points.flatMap(p => [p.x, p.y, p.z]);
    const trianglesIndices = earcut(flatPoints, null, 3);

    let normals = [];
    VertexData.ComputeNormals(flatPoints, trianglesIndices, normals);

    const vertexData = new VertexData();
    vertexData.positions = flatPoints;
    vertexData.indices = trianglesIndices;
    vertexData.normals = normals;
    vertexData.applyToMesh(mesh);

    return mesh;
}
